import { AuthResponse } from '@interfaces/auth';

export const refreshDomainToken = async (
  refreshTokenData: string,
  refreshUrl: string
): Promise<AuthResponse> => {
  const res = await fetch(refreshUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refreshToken: refreshTokenData }),
    cache: 'no-store',
  });

  if (res.status >= 400) {
    let error;

    try {
      error = await res.json();
    } catch {
      throw Error('An error occurred', {
        cause: res,
      });
    }

    throw Error(error.message, {
      cause: res,
    });
  }

  return await res.json();
};
